import SubHeader from "../components/sub/SubHeader";
import SubVisual from '../components/sub/SubVisual';
import subVisualStay from '../img/sub/sub_visual_stay.jpg';
import styled from 'styled-components';
import stay01_01 from '../img/sub/stay/stay01_01.jpg';
import stay01_02 from '../img/sub/stay/stay01_02.jpg';
import stay01_03 from '../img/sub/stay/stay01_03.jpg';
import stay02_01 from '../img/sub/stay/stay02_01.jpg';
import stay02_02 from '../img/sub/stay/stay02_02.jpg';
import stay02_03 from '../img/sub/stay/stay02_03.jpg';
import stay03_01 from '../img/sub/stay/stay03_01.jpg';
import stay03_02 from '../img/sub/stay/stay03_02.jpg';
import stay04_01 from '../img/sub/stay/stay04_01.jpg';
import stay04_02 from '../img/sub/stay/stay04_02.jpg';
import stay05_01 from '../img/sub/stay/stay05_01.jpg';
import stay05_02 from '../img/sub/stay/stay05_02.jpg';
import stay06_01 from '../img/sub/stay/stay06_01.jpg';
import stay06_02 from '../img/sub/stay/stay06_02.jpg';
import stay06_03 from '../img/sub/stay/stay06_03.jpg';
import stay06_04 from '../img/sub/stay/stay06_04.jpg';
import detail_01 from '../img/sub/stay/detail_01.jpg';
import detail_02 from '../img/sub/stay/detail_02.jpg';
import detail_03 from '../img/sub/stay/detail_03.jpg';
import detail_04 from '../img/sub/stay/detail_04.jpg';
import detail_05 from '../img/sub/stay/detail_05.jpg';
import detail_06 from '../img/sub/stay/detail_06.jpg';
import detail_07 from '../img/sub/stay/detail_07.jpg';
import detail_08 from '../img/sub/stay/detail_08.jpg';
import detail_09 from '../img/sub/stay/detail_09.jpg';
import detail_10 from '../img/sub/stay/detail_10.jpg';
import detail_11 from '../img/sub/stay/detail_11.jpg';
import detail_12 from '../img/sub/stay/detail_12.jpg';
import detail_13 from '../img/sub/stay/detail_13.jpg';
import detail_14 from '../img/sub/stay/detail_14.jpg';
import detail_15 from '../img/sub/stay/detail_15.jpg';
import detail_16 from '../img/sub/stay/detail_16.jpg';
import detail_17 from '../img/sub/stay/detail_17.jpg';
import detail_18 from '../img/sub/stay/detail_18.jpg';	
import detail_19 from '../img/sub/stay/detail_19.jpg';
import detail_20 from '../img/sub/stay/detail_20.jpg';
import { flexColumn, flexNoneEnd } from '../styles/mixins.style';
import useScrollFadeIn from "../hooks/useScrollFadeIn";
import { FadeInDiv, FadeInImg } from "../styles/fadeIn";
import React, { useState, useEffect } from 'react';


export default function Stay() {
	// 모든 useScrollFadeIn 훅을 컴포넌트 내부로 이동
	const fadeSection01 = useScrollFadeIn();
	const fadeSection01Imgs = [useScrollFadeIn(), useScrollFadeIn(), useScrollFadeIn()];
	const fadeSection02 = useScrollFadeIn();
	const fadeSection02Imgs = [useScrollFadeIn(), useScrollFadeIn(), useScrollFadeIn()];
	const fadeSection03 = useScrollFadeIn();
	const fadeSection03Img = useScrollFadeIn();
	const fadeSection03Img2 = useScrollFadeIn();
	const fadeSection04 = useScrollFadeIn();
	const fadeSection04Imgs = [useScrollFadeIn(), useScrollFadeIn()];
	const fadeSection05 = useScrollFadeIn();
	const fadeSection05Imgs = [useScrollFadeIn(), useScrollFadeIn()];
	const fadeSection06 = useScrollFadeIn();
	const fadeSection06Imgs = [useScrollFadeIn(), useScrollFadeIn(), useScrollFadeIn(), useScrollFadeIn()];
	const fadeSection07Title = useScrollFadeIn();
	const fadeSection07Grid = useScrollFadeIn();
	
	// 20개 detail 이미지 각각에 대해 개별 변수로 선언
	const fadeSection07Img01 = useScrollFadeIn();
	const fadeSection07Img02 = useScrollFadeIn();
	const fadeSection07Img03 = useScrollFadeIn();
	const fadeSection07Img04 = useScrollFadeIn();
	const fadeSection07Img05 = useScrollFadeIn();
	const fadeSection07Img06 = useScrollFadeIn();
	const fadeSection07Img07 = useScrollFadeIn();
	const fadeSection07Img08 = useScrollFadeIn();
	const fadeSection07Img09 = useScrollFadeIn();
	const fadeSection07Img10 = useScrollFadeIn();
	const fadeSection07Img11 = useScrollFadeIn();
	const fadeSection07Img12 = useScrollFadeIn();
	const fadeSection07Img13 = useScrollFadeIn();
	const fadeSection07Img14 = useScrollFadeIn();
	const fadeSection07Img15 = useScrollFadeIn();
	const fadeSection07Img16 = useScrollFadeIn();
	const fadeSection07Img17 = useScrollFadeIn();
	const fadeSection07Img18 = useScrollFadeIn();
	const fadeSection07Img19 = useScrollFadeIn();
	const fadeSection07Img20 = useScrollFadeIn();
	const fadeSection07Imgs = [
		fadeSection07Img01, fadeSection07Img02, fadeSection07Img03, fadeSection07Img04, fadeSection07Img05,
		fadeSection07Img06, fadeSection07Img07, fadeSection07Img08, fadeSection07Img09, fadeSection07Img10,
		fadeSection07Img11, fadeSection07Img12, fadeSection07Img13, fadeSection07Img14, fadeSection07Img15,
		fadeSection07Img16, fadeSection07Img17, fadeSection07Img18, fadeSection07Img19, fadeSection07Img20
	];

	// 모바일 감지
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
	useEffect(() => {
		const handleResize = () => setIsMobile(window.innerWidth <= 768);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	// 모바일 detail 이미지 visible state (한 장씩 순차 fade-in)
	const [mobileDetailVisible, setMobileDetailVisible] = useState<boolean[]>(Array(detailImages.length).fill(false));

	// 타이틀 fade-in 후 모바일 detail 이미지 순차 fade-in
	useEffect(() => {
		if (!isMobile) return;
		if (!fadeSection07Title.visible) return;
		// 한 장씩 순차적으로 visible true
		let timeouts: NodeJS.Timeout[] = [];
		detailImages.forEach((_, i) => {
			timeouts.push(setTimeout(() => {
				setMobileDetailVisible(prev => {
					const next = [...prev];
					next[i] = true;
					return next;
				});
			}, i * 120)); 
		});
		return () => timeouts.forEach(t => clearTimeout(t));
	}, [isMobile, fadeSection07Title.visible]);

	return (
		<StayLayout>
			<SubHeader />
			<SubVisual
				image={subVisualStay}
				title="5개의 층, 5개의 특별한 공간"
				subtitle={
					<>
						녹음이 머무는 공간의 속삭임에<br className="mobile-br" /> 빠져 보시길 바랍니다.
					</>
				}
			/>
			<StaySection>
				{isMobile ? (
					<StayFloorSection>
						<StayIntro>
							<h2>1F 자쿠지 & 사우나</h2>
							<p>바위, 나무, 자갈, <br />바다의 자연을 담은 공간</p>
						</StayIntro>
						<StayImagesSection01>
							<div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', flex: '1' }}>
								<div>
									<ZigzagImageRow $right={true} style={{ height: '100%' }}>
										<FadeInImg src={stay01_01} alt="1F 자쿠지 & 사우나" ref={fadeSection01Imgs[0].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection01Imgs[0].visible} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
									</ZigzagImageRow>
								</div>
								<div>
									<ZigzagImageRow $right={false} style={{ height: '100%' }}>
										<FadeInImg src={stay01_03} alt="1F 자쿠지 & 사우나" ref={fadeSection01Imgs[1].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection01Imgs[1].visible} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
									</ZigzagImageRow>
								</div>
							</div>
							<div style={{ flex: '1' }}>
								<ZigzagImageRow $right={true} style={{ height: '100%' }}>
									<FadeInImg src={stay01_02} alt="1F 자쿠지 & 사우나" ref={fadeSection01Imgs[2].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection01Imgs[2].visible} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
								</ZigzagImageRow>
							</div>
						</StayImagesSection01>
					</StayFloorSection>
				) : (
					<StayFloorSection>
						<FadeInDiv ref={fadeSection01.ref} $visible={fadeSection01.visible} className="stay-section01">
							<StayIntro>
								<h2>1F 자쿠지 & 사우나</h2>
								<p>바위, 나무, 자갈, <br />바다의 자연을 담은 공간</p>
							</StayIntro>
						</FadeInDiv>
						<StayImagesSection01>
							<div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', flex: '1' }}>
								<div>
									<ZigzagImageRow $right={true} style={{ height: '100%' }}>
										<FadeInImg src={stay01_01} alt="1F 자쿠지 & 사우나" ref={fadeSection01Imgs[0].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection01Imgs[0].visible} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
									</ZigzagImageRow>
								</div>
								<div>
									<ZigzagImageRow $right={false} style={{ height: '100%' }}>
										<FadeInImg src={stay01_02} alt="1F 자쿠지 & 사우나" ref={fadeSection01Imgs[1].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection01Imgs[1].visible} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
									</ZigzagImageRow>
								</div>
							</div>
							<div style={{ flex: '1' }}>
								<ZigzagImageRow $right={true} style={{ height: '100%' }}>
									<FadeInImg src={stay01_03} alt="1F 자쿠지 & 사우나" ref={fadeSection01Imgs[2].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection01Imgs[2].visible} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
								</ZigzagImageRow>
							</div>
						</StayImagesSection01>
					</StayFloorSection>
				)}
				{isMobile ? (
					<StayFloorSection>
						<StayIntro>
							<h2>1.5F 침실 & 다실</h2>
							<p>
								깊고 고요한 동굴처럼, <br className="mobile-br" />세상의 소음을 잠시 접어두는 안식의 공간 <br />
								나직한 숨결로 스며드는 빛과 <br className="mobile-br" />원목의 따스함이 <br className="mobile-br" />하루의 끝에 전하는 포근한 속삭임
							</p>
						</StayIntro>
						<StayImagesSection02>
							<div style={{ gridArea: 'image1', transitionDelay: '0.2s' }}>
								<ZigzagImageRow $right={true}>
									<FadeInImg src={stay02_01} alt="1.5F 침실 & 다실" ref={fadeSection02Imgs[0].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection02Imgs[0].visible} />
								</ZigzagImageRow>
							</div>
							<div style={{ gridArea: 'image2', transitionDelay: '0.3s' }}>
								<ZigzagImageRow $right={false}>
									<FadeInImg src={stay02_02} alt="1.5F 침실 & 다실" ref={fadeSection02Imgs[1].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection02Imgs[1].visible} />
								</ZigzagImageRow>
							</div>
							<div style={{ gridArea: 'image3', transitionDelay: '0.4s' }}>
								<ZigzagImageRow $right={true}>
									<FadeInImg src={stay02_03} alt="1.5F 침실 & 다실" ref={fadeSection02Imgs[2].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection02Imgs[2].visible} />
								</ZigzagImageRow>
							</div>
						</StayImagesSection02>
					</StayFloorSection>
				) : (
					<StayFloorSection>
						<FadeInDiv ref={fadeSection02.ref} $visible={fadeSection02.visible} className="stay-section02">
							<StayIntro>
								<h2>1.5F 침실 & 다실</h2>
								<p>
									깊고 고요한 동굴처럼, <br className="mobile-br" />세상의 소음을 잠시 접어두는 안식의 공간 <br />
									나직한 숨결로 스며드는 빛과 <br className="mobile-br" />원목의 따스함이 <br className="mobile-br" />하루의 끝에 전하는 포근한 속삭임
								</p>
							</StayIntro>
						</FadeInDiv>
						<StayImagesSection02>
							<div style={{ gridArea: 'image1', transitionDelay: '0.2s' }}>
								<ZigzagImageRow $right={true}>
									<FadeInImg src={stay02_01} alt="1.5F 침실 & 다실" ref={fadeSection02Imgs[0].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection02Imgs[0].visible} />
								</ZigzagImageRow>
							</div>
							<div style={{ gridArea: 'image2', transitionDelay: '0.3s' }}>
								<ZigzagImageRow $right={false}>
									<FadeInImg src={stay02_02} alt="1.5F 침실 & 다실" ref={fadeSection02Imgs[1].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection02Imgs[1].visible} />
								</ZigzagImageRow>
							</div>
							<div style={{ gridArea: 'image3', transitionDelay: '0.4s' }}>
								<ZigzagImageRow $right={true}>
									<FadeInImg src={stay02_03} alt="1.5F 침실 & 다실" ref={fadeSection02Imgs[2].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection02Imgs[2].visible} />
								</ZigzagImageRow>
							</div>
						</StayImagesSection02>
					</StayFloorSection>
				)}
				{isMobile ? (
					<StayFloorSection>
						<StayIntro>
							<h2>2F 키친 & 다이닝</h2>
							<p>
								천창 사이로 스며드는 햇살 <br />
								와인 한 잔 혹은 커피 한 잔과 어울리는 선율 <br />
								150년이 넘는 오랜 시간을 버텨온<br className="mobile-br" /> 견고한 소재의 티크 테이블과 의자 <br />
								노곤했던 하루를 어루만져주는 공간
							</p>
						</StayIntro>
						<StaySection03Grid>
							<div>
								<div>
									<ZigzagImageRow $right={true}>
										<FadeInImg src={stay03_01} alt="2F 키친 & 다이닝" ref={fadeSection03Img.ref as React.RefObject<HTMLImageElement>} $visible={fadeSection03Img.visible} />
									</ZigzagImageRow>
								</div>
							</div>
							<div>
								<StayImages>
									<div style={{ transitionDelay: '0.2s' }}>
										<ZigzagImageRow $right={false}>
											<FadeInImg src={stay03_02} alt="2F 키친 & 다이닝" ref={fadeSection03Img2.ref as React.RefObject<HTMLImageElement>} $visible={fadeSection03Img2.visible} />
										</ZigzagImageRow>
									</div>
								</StayImages>
							</div>
						</StaySection03Grid>
					</StayFloorSection>
				) : (
					<StayFloorSection>
						<FadeInDiv ref={fadeSection03.ref} $visible={fadeSection03.visible} className="stay-section03">
							<StaySection03Grid>
								<div>
									<StayIntro>
										<h2>2F 키친 & 다이닝</h2>
										<p>
											천창 사이로 스며드는 햇살 <br />
											와인 한 잔 혹은 커피 한 잔과 어울리는 선율 <br />
											150년이 넘는 오랜 시간을 버텨온<br className="mobile-br" /> 견고한 소재의 티크 테이블과 의자 <br />
											노곤했던 하루를 어루만져주는 공간
										</p>
									</StayIntro>
									<div>
										<ZigzagImageRow $right={true}>
											<FadeInImg src={stay03_01} alt="2F 키친 & 다이닝" ref={fadeSection03Img.ref as React.RefObject<HTMLImageElement>} $visible={fadeSection03Img.visible} />
										</ZigzagImageRow>
									</div>
								</div>
								<div>
									<StayImages>
										<div style={{ transitionDelay: '0.2s' }}>
											<ZigzagImageRow $right={false}>
												<FadeInImg src={stay03_02} alt="2F 키친 & 다이닝" ref={fadeSection03Img2.ref as React.RefObject<HTMLImageElement>} $visible={fadeSection03Img2.visible} />
											</ZigzagImageRow>
										</div>
									</StayImages>
								</div>
							</StaySection03Grid>
						</FadeInDiv>
					</StayFloorSection>
				)}
				{isMobile ? (
					<StayFloorSection>
						<StayIntro>
							<h2>2F 건식 화장실</h2>
							<p>
								공간이 감각을 일깨웁니다. <br />
								시선 위 하늘에서 빛이 닿을 때마다 <br />
								푸른색 타일이 물결처럼 반짝입니다.
							</p>
						</StayIntro>
						<StayImagesHalfGap>
							<ResponsiveImageWrapper style={{ transitionDelay: '0.2s' }}>
								<ZigzagImageRow $right={true}>
									<FadeInImg src={stay04_01} alt="2F 건식 화장실" ref={fadeSection04Imgs[0].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection04Imgs[0].visible} />
								</ZigzagImageRow>
							</ResponsiveImageWrapper>
							<ResponsiveImageWrapper style={{ transitionDelay: '0.3s' }}>
								<ZigzagImageRow $right={false}>
									<FadeInImg src={stay04_02} alt="2F 건식 화장실" ref={fadeSection04Imgs[1].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection04Imgs[1].visible} />
								</ZigzagImageRow>
							</ResponsiveImageWrapper>
						</StayImagesHalfGap>
					</StayFloorSection>
				) : (
					<StayFloorSection>
						<FadeInDiv ref={fadeSection04.ref} $visible={fadeSection04.visible} className="stay-section04">
							<StaySectionGridHalf>
								<StayIntro>
									<h2>2F 건식 화장실</h2>
									<p>
										공간이 감각을 일깨웁니다. <br />
										시선 위 하늘에서 빛이 닿을 때마다 <br />
										푸른색 타일이 물결처럼 반짝입니다.
									</p>
								</StayIntro>
								<StayImagesHalfGap>
									<ResponsiveImageWrapper style={{ transitionDelay: '0.2s' }}>
										<ZigzagImageRow $right={true}>
											<FadeInImg src={stay04_01} alt="2F 건식 화장실" ref={fadeSection04Imgs[0].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection04Imgs[0].visible} />
										</ZigzagImageRow>
									</ResponsiveImageWrapper>
									<ResponsiveImageWrapper style={{ transitionDelay: '0.3s' }}>
										<ZigzagImageRow $right={false}>
											<FadeInImg src={stay04_02} alt="2F 건식 화장실" ref={fadeSection04Imgs[1].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection04Imgs[1].visible} />
										</ZigzagImageRow>
									</ResponsiveImageWrapper>
								</StayImagesHalfGap>
							</StaySectionGridHalf>
						</FadeInDiv>
					</StayFloorSection>
				)}
				{isMobile ? (
					<StayFloorSection>
						<StayIntro>
							<h2>2.5F 야외 바베큐</h2>
							<p>
								벽과 벽 사이, <br />
								조용히 시선을 나누는 두 개의 등대<br />
								그 사이를 건너는 통통배가 담긴 한 폭의 풍경화<br /><br />
								바람도 쉬어가는 오후, <br />
								마음 한켠에 머무는 여유의 풍경
							</p>
						</StayIntro>
						<StayImagesHalfGap>
							<ResponsiveImageWrapper style={{ transitionDelay: '0.2s' }}>
								<ZigzagImageRow $right={true}>
									<FadeInImg src={stay05_01} alt="2.5F 야외 바베큐" ref={fadeSection05Imgs[0].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection05Imgs[0].visible} />
								</ZigzagImageRow>
							</ResponsiveImageWrapper>
							<ResponsiveImageWrapper style={{ transitionDelay: '0.3s' }}>
								<ZigzagImageRow $right={false}>
									<FadeInImg src={stay05_02} alt="2.5F 야외 바베큐" ref={fadeSection05Imgs[1].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection05Imgs[1].visible} />
								</ZigzagImageRow>
							</ResponsiveImageWrapper>
						</StayImagesHalfGap>
					</StayFloorSection>
				) : (
					<StayFloorSection>
						<FadeInDiv ref={fadeSection05.ref} $visible={fadeSection05.visible} className="stay-section05">
							<StaySectionGridHalf>
								<StayIntro>
									<h2>2.5F 야외 바베큐</h2>
									<p>
										벽과 벽 사이, <br />
										조용히 시선을 나누는 두 개의 등대<br />
										그 사이를 건너는 통통배가 담긴 한 폭의 풍경화<br /><br />
										바람도 쉬어가는 오후, <br />
										마음 한켠에 머무는 여유의 풍경
									</p>
								</StayIntro>
								<StayImagesHalfGap>
									<ResponsiveImageWrapper style={{ transitionDelay: '0.2s' }}>
										<ZigzagImageRow $right={true}>
											<FadeInImg src={stay05_01} alt="2.5F 야외 바베큐" ref={fadeSection05Imgs[0].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection05Imgs[0].visible} />
										</ZigzagImageRow>
									</ResponsiveImageWrapper>
									<ResponsiveImageWrapper style={{ transitionDelay: '0.3s' }}>
										<ZigzagImageRow $right={false}>
											<FadeInImg src={stay05_02} alt="2.5F 야외 바베큐" ref={fadeSection05Imgs[1].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection05Imgs[1].visible} />
										</ZigzagImageRow>
									</ResponsiveImageWrapper>
								</StayImagesHalfGap>
							</StaySectionGridHalf>
						</FadeInDiv>
					</StayFloorSection>
				)}
				{isMobile ? (
					<StayFloorSection>
						<StayIntro>
							<h2>3F 루프탑 수영장</h2>
							<p>
								벽 너머로 스치는 바다의 바람<br />
								햇살이 나를 감싸 안는 시간,<br /><br />
								바람과 햇살이 선사하는 진짜 휴가
							</p>
						</StayIntro>
						<StaySection06Grid>
							<div>
								<FadeInDiv ref={fadeSection06Imgs[1].ref} $visible={fadeSection06Imgs[1].visible}>
									<StayImagesFlex>
										<ZigzagImageRow $right={true}>
											<FadeInImg src={stay06_01} alt="3F 루프탑 수영장" $visible={fadeSection06Imgs[1].visible} />
										</ZigzagImageRow>
									</StayImagesFlex>
								</FadeInDiv>
							</div>
							<StayImagesColumn>
								<div>
									<ResponsiveImageWrapper>
										<ZigzagImageRow $right={false}>
											<FadeInImg src={stay06_02} style={{ transitionDelay: '0.1s' }} alt="3F 루프탑 수영장" ref={fadeSection06Imgs[2].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection06Imgs[2].visible} />
										</ZigzagImageRow>
									</ResponsiveImageWrapper>
								</div>
								<div>
									<ResponsiveImageWrapper>
										<ZigzagImageRow $right={true}>
											<FadeInImg src={stay06_03} style={{ transitionDelay: '0.1s' }} alt="3F 루프탑 수영장" ref={fadeSection06Imgs[3].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection06Imgs[3].visible} />
										</ZigzagImageRow>
									</ResponsiveImageWrapper>
								</div>
							</StayImagesColumn>
							<StayImagesFlex style={{ transitionDelay: '0.3s' }}>
								<ResponsiveImageWrapper>
									<ZigzagImageRow $right={false}>
										<FadeInImg src={stay06_04} alt="3F 루프탑 수영장" ref={fadeSection06Imgs[3].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection06Imgs[3].visible} />
									</ZigzagImageRow>
								</ResponsiveImageWrapper>
							</StayImagesFlex>
						</StaySection06Grid>
					</StayFloorSection>
				) : (
					<StayFloorSection>
						<FadeInDiv ref={fadeSection06.ref} $visible={fadeSection06.visible} className="stay-section06">
							<StaySection06Grid>
								<div>
									<FadeInDiv ref={fadeSection06Imgs[0].ref} $visible={fadeSection06Imgs[0].visible}>
										<StayIntro>
											<h2>3F 루프탑 수영장</h2>
											<p>
												벽 너머로 스치는 바다의 바람<br />
												햇살이 나를 감싸 안는 시간,<br /><br />
												바람과 햇살이 선사하는 진짜 휴가
											</p>
										</StayIntro>
									</FadeInDiv>
									<FadeInDiv ref={fadeSection06Imgs[1].ref} $visible={fadeSection06Imgs[1].visible}>
										<StayImagesFlex>
											<ZigzagImageRow $right={true}>
												<FadeInImg src={stay06_01} alt="3F 루프탑 수영장" $visible={fadeSection06Imgs[1].visible} />
											</ZigzagImageRow>
										</StayImagesFlex>
									</FadeInDiv>
								</div>
								<StayImagesColumn>
									<div>
										<ResponsiveImageWrapper>
											<ZigzagImageRow $right={false}>
												<FadeInImg src={stay06_02} style={{ transitionDelay: '0.1s' }} alt="3F 루프탑 수영장" ref={fadeSection06Imgs[2].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection06Imgs[2].visible} />
											</ZigzagImageRow>
										</ResponsiveImageWrapper>
									</div>
									<div>
										<ResponsiveImageWrapper>
											<ZigzagImageRow $right={true}>
												<FadeInImg src={stay06_03} style={{ transitionDelay: '0.1s' }} alt="3F 루프탑 수영장" ref={fadeSection06Imgs[3].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection06Imgs[3].visible} />
											</ZigzagImageRow>
										</ResponsiveImageWrapper>
									</div>
								</StayImagesColumn>
								<StayImagesFlex style={{ transitionDelay: '0.3s' }}>
									<ResponsiveImageWrapper>
										<ZigzagImageRow $right={false}>
											<FadeInImg src={stay06_04} alt="3F 루프탑 수영장" ref={fadeSection06Imgs[3].ref as React.RefObject<HTMLImageElement>} $visible={fadeSection06Imgs[3].visible} />
										</ZigzagImageRow>
									</ResponsiveImageWrapper>
								</StayImagesFlex>
							</StaySection06Grid>
						</FadeInDiv>
					</StayFloorSection>
				)}
				{isMobile ? (
					<StayFloorSection>
						<StaySection07Title>Thoughtful Details of Horigul</StaySection07Title>
						<DetailImagesGrid>
							{detailImages.map((img, i) => (
								<DetailImageStyled key={i}>
									<img src={img} alt={`Detail Image ${i + 1}`} />
								</DetailImageStyled>
							))}
						</DetailImagesGrid>
					</StayFloorSection>
				) : (
					<StayFloorSection>
						<FadeInDiv ref={fadeSection07Title.ref} $visible={fadeSection07Title.visible} className="stay-section07-title">
							<StaySection07Title>Thoughtful Details of Horigul</StaySection07Title>
						</FadeInDiv>
						<FadeInDiv ref={fadeSection07Grid.ref} $visible={fadeSection07Grid.visible} className="stay-section07-grid">
							<DetailImagesGrid>
								{detailImages.map((img, i) => (
									<DetailImageStyled key={i}>
										<FadeInImg
											src={img}
											alt={`Detail Image ${i + 1}`}
											ref={fadeSection07Imgs[i].ref as React.RefObject<HTMLImageElement>}
											$visible={fadeSection07Imgs[i].visible}
											$delay={`${i * 0.1 + 0.2}s`}
										/>
									</DetailImageStyled>
								))}
							</DetailImagesGrid>
						</FadeInDiv>
					</StayFloorSection>
				)}
			</StaySection>
		</StayLayout>
	);
}

const detailImages = [
	detail_01, detail_02, detail_03, detail_04, detail_05,
	detail_06, detail_07, detail_08, detail_09, detail_10,
	detail_11, detail_12, detail_13, detail_14, detail_15,
	detail_16, detail_17, detail_18, detail_19, detail_20
];

const ZigzagImageRow = styled.div<{ $right?: boolean }>`
	@media (max-width: 768px) {
		display: flex;
		justify-content: ${props => props.$right ? 'flex-end' : 'flex-start'};
		margin-left: ${props => props.$right ? '1.125rem' : '0'};
		margin-right: ${props => !props.$right ? '1.125rem' : '0'};
	}
`;

const ResponsiveImageWrapper = styled.div`
	@media (max-width: 768px) {
		width: 100% !important;
	}
`;

const StayFloorSection = styled.section`
	margin-bottom: 10rem;
	@media (max-width: 768px) {
		margin-bottom: 10rem;
	}
`;

const StayLayout = styled.div`
	margin-left: 250px;
	@media (max-width: 1024px) {
		margin-left: 0;
	}
`;

const StayIntro = styled.div`
	${flexColumn}
	margin-bottom: 1rem;
	h2 {
		font-size: 1.75rem;
		font-weight: 500;
		margin-bottom: 0.625rem;
	}
	p {
		color: #ffffff80;
		font-size: 1.125rem;
		line-height: 2rem;
	}
	@media (max-width: 1024px) {
		margin-left: 1rem;
		h2 {
			font-size: 1.5rem;
		}
		p {
			font-size: 1rem;
		}
	}
	@media (max-width: 768px) {
		margin-left: 0;
		h2 {
			font-size: 1.25rem;
			font-weight: 500;
			text-align: center;
		}
		p {
			line-height: 1.625rem;
			text-align: center;
		}
	}
`;

const StaySection = styled.section`
	padding-right: 2rem;
	@media (max-width: 1024px) {
		margin: 0 auto;
		padding-right: 0;
	}
	.stay-section07 {
		margin-bottom: 0;
	}
`;

const StayImages = styled.div`
	display: grid;
	width: 100%;
	box-sizing: border-box;
	gap: 1rem;
	&.section01 {
		grid-template-areas: "image1 image3" "image2 image3";
	}
	&.section02 {
		grid-template-areas: "image1 image2 image3";
	}
	img {
		width: 100%;
		height: 100%;
		display: block;
	}
	@media (max-width: 768px) {
		display: flex;
		flex-direction: column;
		gap: 0.75rem;
	}
`;

const StayImagesSection01 = styled.div`
	display: grid;
	grid-template-columns: 0.7fr 1fr;
	width: 100%;
	box-sizing: border-box;
	gap: 1rem;
	align-items: stretch;
	height: 100%;
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}
	@media (max-width: 768px) {
		display: flex;
		flex-direction: column;
		gap: 0.75rem;
		> div:last-child {
			order: 3;
		}
	}
`;

const StayImagesSection02 = styled.div`
	display: grid;
	width: 100%;
	box-sizing: border-box;
	grid-template-areas: "image1 image2 image3";
	gap: 1rem;
	align-items: end;
	img {
		width: 100%;
		height: auto;
		display: block;
	}
	@media (max-width: 768px) {
		grid-template-areas: "image1" "image2" "image3";
		gap: 0.75rem;
	}
`;

const StaySection03Grid = styled.div`
	display: grid;
	grid-template-columns: 0.8fr 1fr;
	gap: 1rem;
	align-items: end;
	div > div > img, div > div > ${''}FadeInImg {
		width: 100%;
		height: auto;
		display: block;
	}
	@media (max-width: 768px) {
		grid-template-columns: 1fr;
		gap: 0.75rem;
	}
`;

const StaySectionGridHalf = styled.div`
	display: grid;
	grid-template-columns: 0.5fr 1fr;
	align-items: center;
	gap: 1rem;
	@media (max-width: 768px) {
		grid-template-columns: 1fr;
		gap: 0.75rem;
	}
`;

const StayImagesHalfGap = styled.div`
	display: flex;
	width: 100%;
	box-sizing: border-box;
	gap: 1rem;
	align-items: end;
	img {
		width: 100%;
		height: auto;
		display: block;
	}
	@media (max-width: 768px) {
		flex-direction: column;
		align-items: center;
		gap: 0.75rem;
	}
`;

const StaySection06Grid = styled.div`
	display: grid;
	grid-template-columns: 0.6fr 0.9fr 1fr;
	gap: 1rem;
	align-items: end;
	@media (max-width: 1024px) and (min-width: 769px) {
		grid-template-columns: 300px 0.9fr 1fr;
	}
	@media (max-width: 768px) {
		grid-template-columns: 1fr;
		gap: 0.75rem;
	}
`;

const StayImagesColumn = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	box-sizing: border-box;
	gap: 1rem;
	img {
		width: 100%;
		height: auto;
		display: block;
	}
	> div {
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}
`;

const StayImagesFlex = styled.div`
	width: 100%;
	box-sizing: border-box;
	img {
		width: 100%;
		height: auto;
		display: block;
	}
`;

const StaySection07Title = styled.h2`
	font-size: 1.5rem;
	font-family: 'MaruBuriExtraLight', sans-serif;
	font-weight: 300;
	margin-bottom: 1rem;
	@media (max-width: 768px) {
		font-size: 1.25rem;
		text-align: center;
	}
`;

const DetailImages = styled.div`
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 1rem;
	img {
		width: 100%;
		height: 100%;
		filter: brightness(75%);
		transition: filter 0.2s ease;
		&:hover {
			filter: brightness(100%);
		}
	}
	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

const DetailImagesGrid = styled.div`
	display: grid;
	width: 100%;
	box-sizing: border-box;
	grid-template-columns: repeat(5, 1fr);
	gap: 1rem;
	img {
		width: 100%;
		height: auto;
		display: block;
	}
	@media (max-width: 1024px) {
		gap: 0.5rem;
		grid-template-columns: repeat(3, 1fr);
	}
	@media (max-width: 768px) {
		grid-template-columns: repeat(2, 1fr);
	}
`;

const DetailImageStyled = styled.div`
	img {
		width: 100%;
		height: 100%;
		filter: brightness(75%);
		transition: filter 0.2s ease;
		&:hover {
			filter: brightness(100%);
		}
		@media (max-width: 768px) {
			filter: brightness(100%);
		}
	}
`;